module.exports = __webpack_public_path__ + "static/coffee-beans-5712774_1920@2x-8eae27142dc7304569d4aed62ce34f50.png";